import React, { Component } from "react";

import { Button, Card, CardBody, Col, Row } from "reactstrap";

// datatable related plugins
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";

import { connect } from "react-redux";
import PropTypes from "prop-types";
import RemoteTable from "../../../components/Common/RemoteTable";
import SweetAlert from "react-bootstrap-sweetalert";
import styled from "styled-components";
import OfferTrackerModal from "./components/OfferTrackerModal";
import { withRouter } from "react-router-dom";
import {
  addOfferTracker,
  deleteOfferTracker,
  getOfferTrackersList,
  updateTrackerOfferProfile,
} from "../../../store/offers/actions";

class OfferTracker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      sizePerPage: 10,
      filter_name: [],
      deleteAlert: null,
      viewAddOfferTracker: false,
      editData: null,
    };
  }

  handleTableChange = data => {
    this.props.getOfferTrackersList(data, this.props.match.params.offerId);
  };

  handleChangeDeleteAlert = data => {
    this.setState({ deleteAlert: data });
  };

  toggleViewAddOfferTracker = () => {
    this.setState(prevState => ({
      viewAddOfferTracker: !prevState.viewAddOfferTracker,
      editData: null,
    }));
  };

  render() {
    const actionsFormatter = (cell, row) => {
      const onClickDelete = () => {
        this.handleChangeDeleteAlert({
          title: `Delete "${row.tracking_link}"!`,
          onConfirm: () => {
            this.props.deleteOfferTracker(
              row.id,
              {
                ...this.props.data,
                page:
                  this.props.data.results.length === 1
                    ? 1
                    : this.props.data.page,
              },
              this.props.match.params.offerId
            );
            this.handleChangeDeleteAlert(null);
          },
        });
      };

      const onClickEdit = e => {
        onClickRow(e, row, "edit");
      };

      return (
        <React.Fragment>
          {this.props.permissions["change_offertrackermodel"] && (
            <Button
              type="button"
              className="btn btn-primary  btn-sm"
              onClick={onClickEdit}
            >
              <i className="mdi mdi-circle-edit-outline d-block font-size-16" />
            </Button>
          )}
          {this.props.permissions["delete_offertrackermodel"] && (
            <Button
              type="button"
              className="btn btn-danger btn-sm m-1"
              onClick={onClickDelete}
            >
              <i className="mdi mdi-trash-can d-block font-size-16" />
            </Button>
          )}
        </React.Fragment>
      );
    };

    const nameFormatter = (cell, row, label) => {
      return (
        <NameLink onClick={e => onClickRow(e, row, "edit")}>
          {row[label]}
        </NameLink>
      );
    };

    const columns = [
      {
        dataField: "tracking_link",
        text: "Tracking link",
        sort: true,
        formatter: (cell, row) => nameFormatter(cell, row, "tracking_link"),
      },
      {
        dataField: "tracking_platform",
        text: "Platform",
        sort: true,
        formatter: (cell, row) => nameFormatter(cell, row, "tracking_platform"),
      },
      {
        dataField: "actions",
        text: "Actions",
        sort: false,
        formatter: actionsFormatter,
      },
    ];

    const onClickRow = (e, row, type) => {
      this.setState(prevState => ({
        viewAddOfferTracker: !prevState.viewAddOfferTracker,
        editData: type === "edit" ? row : null,
      }));
    };

    return (
      <React.Fragment>
        {this.state.viewAddOfferTracker && (
          <OfferTrackerModal
            toggle={this.toggleViewAddOfferTracker}
            isOpen={this.state.viewAddOfferTracker}
            data={this.props.data}
            addOfferTracker={this.props.addOfferTracker}
            offerId={this.props.match.params.offerId}
            editData={this.state.editData}
            permissions={this.props.permissions}
            updateTrackerOfferProfile={this.props.updateTrackerOfferProfile}
            handleTableChange={this.handleTableChange}
          />
        )}
        {this.state.deleteAlert && (
          <SweetAlert
            showCancel
            confirmBtnText="Delete"
            cancelBtnText="Cancel"
            confirmBtnBsStyle="danger"
            cancelBtnBsStyle=""
            title={this.state.deleteAlert.title}
            onCancel={() => this.handleChangeDeleteAlert(null)}
            onConfirm={this.state.deleteAlert.onConfirm}
          >
            <p>
              You are about to delete this link? <br /> If you are not sure, you
              can close this form.
            </p>
          </SweetAlert>
        )}
        <Row>
          <Col className="col-12">
            <Card>
              <CardBody>
                <RemoteTable
                  onTableChange={this.handleTableChange}
                  columns={columns}
                  data={this.props.data}
                  loading={this.props.loading}
                >
                  {this.props.permissions &&
                    this.props.permissions["add_offertrackermodel"] ===
                      "add_offertrackermodel" && (
                      <Button
                        type="button"
                        color="success"
                        className="btn-rounded mb-2 me-2"
                        onClick={this.toggleViewAddOfferTracker}
                      >
                        <i className="mdi mdi-plus me-1" /> Add offer tracker
                      </Button>
                    )}
                </RemoteTable>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

const NameLink = styled.div`
  transition-duration: 0.1s;
  &:hover {
    color: rgb(85, 110, 230);
    transition-duration: 0.1s;
  }
`;

OfferTracker.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      offerId: PropTypes.node,
    }).isRequired,
  }).isRequired,
  data: PropTypes.any,
  loading: PropTypes.bool,
  getOfferTrackersList: PropTypes.func,
  addOfferTracker: PropTypes.func,
  deleteOfferTracker: PropTypes.func,
  history: PropTypes.any,
  permissions: PropTypes.any,
  updateTrackerOfferProfile: PropTypes.func,
};

const mapStateToProps = state => ({
  loading: state.Offers.loading_trackers_list,
  permissions: state.User.permissions,
});

export default withRouter(
  connect(mapStateToProps, {
    getOfferTrackersList,
    addOfferTracker,
    updateTrackerOfferProfile,
    deleteOfferTracker,
  })(OfferTracker)
);
